// src/assessment2/assessment2Access.js — Assessment 2 (PLAN_ASSESSMENT2.md)
// Gate de acceso del módulo: solo super-admin y solo las organizaciones listadas
// (decisión Erwin, 2026-09-16). Para revertir el módulo basta con borrar la
// carpeta src/assessment2 y las líneas de enganche en AppRoutes/App/SideDrawer.

export const ASSESSMENT2_ORGANIZATION_IDS = [
  '03e9dc12-d86b-4ce2-b41c-06334238b6d4',
];

export const canUseAssessment2 = ({ user, organization }) => {
  const isSuperAdmin = user?.rol === 'super-admin';
  const orgAllowed = Boolean(organization) && ASSESSMENT2_ORGANIZATION_IDS.includes(organization);
  return isSuperAdmin && orgAllowed;
};
